import React, { useState } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import {
  fade,
  List,
  ListItemIcon,
  ListItemText,
  Collapse,
  makeStyles,
} from '@material-ui/core'
import ExpandLess from '@material-ui/icons/ExpandLess'
import ExpandMore from '@material-ui/icons/ExpandMore'

import { colors } from 'theme'

import PageIcon from 'ui/PageIcon'
import ListItem from './ListItem'

const useStyles = makeStyles(theme => ({
  icon: {
    minWidth: theme.spacing(5),
  },
  innerList: {
    paddingLeft: theme.spacing(5),
  },
  primaryText: {
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  wrapper: {
    '&&': {
      borderRadius: 8,
      backgroundColor: ({ selected }) =>
        selected ? fade(colors.aqua500, 0.1) : 'transparent',

      '&:hover': {
        backgroundColor: ({ selected }) =>
          selected ? fade(colors.aqua500, 0.2) : fade(colors.background, 0.05),
      },
    },
  },
}))

export const toggleCollapse = (setFn, oldValue) => () => setFn(!oldValue)

export const ExpandIcon = ({ children, isVisible }) => {
  if (!children) return null

  return isVisible ? <ExpandLess /> : <ExpandMore />
}

const DrawerItem = ({
  icon,
  iconColor,
  withIcon = true,
  children,
  to,
  selected,
  className,
  label,
  onLinkClick,
}) => {
  const classes = useStyles({ selected })
  const [isVisible, setIsVisible] = useState(true)
  const additionalProps = children
    ? { handleClick: toggleCollapse(setIsVisible, isVisible) }
    : { to, onLinkClick }

  return (
    <React.Fragment>
      <ListItem
        selected={selected}
        className={classNames(className, classes.wrapper)}
        {...additionalProps}
      >
        {withIcon && (
          <ListItemIcon className={classes.icon}>
            <PageIcon icon={icon} iconColor={iconColor} />
          </ListItemIcon>
        )}
        <ListItemText
          primary={label}
          className={classes.primaryText}
          primaryTypographyProps={{
            noWrap: true,
            variant: 'body2',
            color: 'textSecondary',
            title: label,
          }}
        />
        <ExpandIcon isVisible={isVisible}>{children}</ExpandIcon>
      </ListItem>
      {children && (
        <Collapse in={isVisible} timeout="auto" unmountOnExit>
          <List component="div" className={classes.innerList}>
            {children}
          </List>
        </Collapse>
      )}
    </React.Fragment>
  )
}

export default DrawerItem

DrawerItem.propTypes = {
  icon: PropTypes.string,
  iconColor: PropTypes.string,
  withIcon: PropTypes.bool,
  label: PropTypes.string.isRequired,
  to: PropTypes.string,
  selected: PropTypes.bool,
  children: PropTypes.node,
  className: PropTypes.string,
  classes: PropTypes.object,
  onLinkClick: PropTypes.func,
}
